export default "__VITE_ASSET__BMGxN4l0__"